import {
  FDAvatar, FDBox,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import fr from 'facet-rest';
import ProposalCFPInsightDialog
  from 'Components/ComponentLibrary/Organisms/ProposalCFPInsight/ProposalCFPInsightDialog';
import { RightColumnProvider } from 'Context/RightColumnContext';
import ScenarioQuestionPicker
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker';
import { dataAttrs } from 'Helpers/Testing';

const ProposalCFPInsight = ({ insightResource, shouldAutoDisplayDialog }) => {
  const messagePlannerFromCustomInsightRel = insightResource.withRelationship(fr.relationships.messagePlannerFromCustomInsight.name,
    (rel) => rel,
    () => null);
  const plannerProfileImageRel = insightResource.withRelationship(fr.relationships.plannerProfileImage.name,
    (rel) => rel,
    () => null);


  const [showMessageButton, setShowMessageButton] = useState(!!messagePlannerFromCustomInsightRel && !shouldAutoDisplayDialog);
  const [isDialogOpen, setIsDialogOpen] = useState(shouldAutoDisplayDialog);

  if (!insightResource) {
    return null;
  }

  const insightContent = insightResource.attr('cfpCustomInsightContent');

  if (!insightContent || insightContent === '') {
    return null;
  }

  const closeDialog = () => {
    setShowMessageButton(!!messagePlannerFromCustomInsightRel);
    setIsDialogOpen(false);
  };

  const openDialog = () => setIsDialogOpen(true);

  return (
    <RightColumnProvider>
      <FDBox>
        <FDStack direction={'row'} spacing={1} alignItems={'center'}>
          <FDAvatar alt={plannerProfileImageRel?.meta('altText')} src={plannerProfileImageRel?.link('related').url()} size={'sm'} />
          <FDSecondaryActionButton label={insightResource.attr('cfpCustomInsightButtonLabel')} onClick={openDialog} {...dataAttrs('cfp-insight-button')} />
        </FDStack>
        <ProposalCFPInsightDialog
          insightResource={insightResource}
          isOpen={isDialogOpen}
          onClose={closeDialog}
          showMessageButton={showMessageButton}
        />
      </FDBox>
      <ScenarioQuestionPicker />
    </RightColumnProvider>
  );
};

ProposalCFPInsight.defaultProps = {
};

ProposalCFPInsight.propTypes = {
  insightResource: PropTypes.object.isRequired,
  shouldAutoDisplayDialog: PropTypes.bool.isRequired,
};

export default ProposalCFPInsight;
